export { MobileFooter } from "./MobileFooter";
export { MobileFooter as default } from "./MobileFooter";
